// src/components/Admin/AdminLayout.jsx
import React, { useMemo } from "react";
import { Box, Drawer } from "@mui/material";
import { createTheme, ThemeProvider, useTheme } from "@mui/material/styles";
import { Outlet } from "react-router-dom";
import AdminSideNav from "./AdminSideNav";
import { BRAND_BLUE } from "../../theme/colors";

const drawerWidth = 260;

export default function AdminLayout() {
  const theme = useTheme();
  const adminTheme = useMemo(
    () => createTheme(theme, {
      palette: { text: { primary: BRAND_BLUE, secondary: BRAND_BLUE } },
    }),
    [theme],
  );

  return (
    <ThemeProvider theme={adminTheme}>
      <Box sx={{ display: "flex", minHeight: "100vh", width: "100%", color: BRAND_BLUE }}>
        {/* ===== LEFT ADMIN SIDE NAV ===== */}
        <Drawer
          variant="permanent"
          sx={{
            width: drawerWidth,
            flexShrink: 0,
            "& .MuiDrawer-paper": {
              width: drawerWidth,
              boxSizing: "border-box",
            },
          }}
        >
          <AdminSideNav />
        </Drawer>

        {/* ===== MAIN CONTENT AREA ===== */}
        <Box
          component="main"
          sx={{
            flex: 1,
            p: 3,
            minWidth: 0,
            background: `
              linear-gradient(
                180deg,
                rgba(112,138,48,0.08) 0%,
                rgba(100,131,21,0.04) 45%,
                rgba(100,131,21,0.02) 100%
              ),
              #fafbf8
            `,
          }}
        >
          <Outlet />
        </Box>
      </Box>
    </ThemeProvider>
  );
}
